/* Número oficial: 8770-4499 | Costa Rica */
export const WA_NUMBER  = '50687704499';
export const WA_MESSAGE = encodeURIComponent('Hola, me interesa información sobre el programa de inglés de American English 🎓');
export const WA_URL     = `https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`;

export const siteInfo = {
  name:     'American English',
  slogan:   'Aprende inglés conversacional y alcanza un nivel B2–C1',
  whatsapp: '+506 8770-4499',
  whatsappUrl: WA_URL,
  phone:    '+506 8770-4499',
  telefonoFijo:     '506 2770-4498',
  telefonoFijoHref: 'tel:+50627704498',
  email:    'mercadeo@americanenglishforbusiness.com',
  stats: { years: 20, locations: 40, graduates: 25000, duration: 9 },
};

export const heroContent = {
  title:       'Domina el inglés en',
  titleSpan:   '9 meses',
  subtitle:    'Programa intensivo 100% conversacional. Alcanza nivel B2-C1 en 9 meses con profesores certificados.',
  checks: [
    'Clases 100% en inglés desde el día 1',
    'Metodología conversacional intensiva',
    'Certificación internacional TOEIC/Oxford opcional',
    '+40 sedes en todo el país',
  ],
  ctaPrimary:   'Prueba de ubicación',
  ctaSecondary: 'Ver el programa',
  discountBadge: '🔥 Consulta hoy y obtén 25% de descuento',
};

export const whyEnglishContent = {
  intro: 'El inglés ya no es un plus — es el requisito mínimo para competir en el mercado laboral costarricense.',
  items: [
    { icon: 'Briefcase',      title: 'Mejores oportunidades',  desc: 'Empresas como Amazon, SYKES e Intel exigen inglés B2+ para sus posiciones.' },
    { icon: 'TrendingUp',     title: 'Salarios hasta 2x más',  desc: 'Los profesionales bilingües ganan en promedio un 60-80% más que sus pares.' },
    { icon: 'Globe',          title: 'Mercado global',         desc: 'Accede a trabajos remotos internacionales sin salir de Costa Rica.' },
    { icon: 'GraduationCap',  title: 'Educación superior',     desc: 'Requisito en universidades públicas y privadas para graduación.' },
    { icon: 'MessageCircle',  title: 'Confianza total',        desc: 'Habla con fluidez y seguridad en reuniones, entrevistas y viajes.' },
  ],
};

/*
 * Los 3 pilares reencuadrados como preguntas que el usuario se hace (CRO ago-2026):
 * conversación → método → respaldo. Cada pilar responde explícitamente una objeción.
 */
export const pilaresContent = [
  {
    number:   '01',
    icon:     'MessageSquare',
    title:    '¿Voy a aprender a hablar de verdad?',
    badge:    null,
    badgeLabel: 'CONVERSACIÓN',
    badgeColor: '#2020A0',
    desc:     'Sí. Hablás en voz alta desde la primera clase, en grupos reducidos y con profesores certificados nivel C1. No memorizás reglas: aprendés a comunicarte en situaciones reales de trabajo y del día a día.',
    benefits: [
      'Hablás inglés desde el día 1',
      'Grupos reducidos con profesores C1',
      'Práctica de situaciones reales',
    ],
  },
  {
    number:   '02',
    icon:     'Monitor',
    title:    '¿Cómo voy a aprender?',
    badge:    null,
    badgeLabel: 'MÉTODO',
    badgeColor: '#2020A0',
    desc:     'Con un método de 7,5 horas semanales que combina plataforma online 24/7 —gramática, fonética y lectura a tu ritmo— con clases en vivo enfocadas en conversación. Una ruta clara que te lleva del nivel A1 al C1 en 9 meses.',
    benefits: [
      '7,5 h semanales estructuradas',
      'Plataforma 24/7 + clases en vivo',
      'Progreso medible de A1 a C1',
    ],
  },
  {
    number:   '03',
    icon:     'Award',
    title:    '¿Qué respaldo obtengo?',
    badge:    null,
    badgeLabel: 'RESPALDO',
    badgeColor: '#CC0000',
    desc:     'Quedás listo para rendir las certificaciones internacionales Oxford y TOEIC —opcionales, vos decidís— con el aval del INA y alineación al Marco Común Europeo (MCER). El respaldo que las empresas piden en la entrevista, no un diploma interno.',
    benefits: [
      'Certificación Oxford & TOEIC',
      'Aval del INA · alineado al MCER',
      'Reconocido por multinacionales',
    ],
  },
];

export const metodologiaContent = [
  {
    step:  1,
    icon:  'Smartphone',
    title: 'Clase asincrónica',
    desc:  'Escritura, fonética, lectura y estructura del idioma a tu ritmo en nuestra plataforma online.',
    hours: '2h 30min/semana',
    color: '#2020A0',
  },
  {
    step:  2,
    icon:  'Video',
    title: 'Clase en vivo',
    desc:  'Conversación, speaking e interacción directa con tu profesor certificado en grupos reducidos.',
    hours: '3h/semana',
    color: '#000060',
  },
  {
    step:  3,
    icon:  'BookOpen',
    title: 'Prácticas y evaluaciones',
    desc:  'Ejercicios de refuerzo, actividades prácticas y evaluaciones para consolidar tu aprendizaje dentro de nuestras plataforma virtual.',
    hours: '2h/semana',
    color: '#CC0000',
  },
];

export const nivelesContent = [
  {
    name:     'Introductorio',
    badge:    '#B0D8F0',
    badgeText:'#000060',
    months:   '3',
    progress: 15,
    goal:     'Evaluación de ubicación y primeros pasos en el idioma. Aprenderás presentaciones básicas, saludos, vocabulario esencial y estructuras simples para iniciar conversaciones cotidianas con confianza.',
    cefr:     'Pre A1',
  },
  {
    name:     'Básico',
    badge:    '#22C55E',
    badgeText:'#fff',
    months:   '3',
    progress: 35,
    goal:     'Desarrollo de conversaciones simples sobre temas cotidianos. Fortalecerás gramática fundamental, vocabulario práctico, comprensión auditiva y redacción básica para comunicarte en situaciones del día a día.',
    cefr:     'A1–A2',
  },
  {
    name:     'Intermedio',
    badge:    '#F59E0B',
    badgeText:'#fff',
    months:   '3',
    progress: 60,
    goal:     'Comunicación efectiva y expresión clara en contextos variados. Mejorarás tu fluidez conversacional, comprensión de textos, expresión de opiniones y manejo de situaciones laborales y sociales en inglés.',
    cefr:     'B1–B2',
  },
  {
    name:     'Avanzado',
    badge:    '#8B5CF6',
    badgeText:'#fff',
    months:   '3',
    progress: 85,
    goal:     'Fluidez en conversaciones complejas y dominio profesional del idioma. Pulimiento de pronunciación, acento avanzado, vocabulario técnico y habilidades para presentaciones, negociaciones y entrevistas en inglés.',
    cefr:     'B2+–C1',
  },
  {
    name:     'Avanzado Plus',
    badge:    '#D4A017',
    badgeText:'#fff',
    months:   '3',
    progress: 98,
    goal:     'Dominio completo del idioma y comunicación ejecutiva. Incluye preparación intensiva para certificaciones internacionales TOEIC y Oxford Placement Test. Enfoque en vocabulario técnico, comprensión auditiva avanzada y estrategias de examen.',
    cefr:     'C1',
    isHighlight: true,
  },
];

export const certificacionesContent = [
  {
    name:   'Oxford Placement Test',
    abbr:   'OPT',
    color:  '#003087',
    desc:   'Evaluación estandarizada de Oxford Placement Test. Certifica tu nivel MCER al inicio y al final del programa.',
    badge:  'Examen opcional',
    intl:   true,
  },
  {
    name:   'TOEIC',
    abbr:   'TOEIC',
    color:  '#0066CC',
    desc:   'El examen de inglés empresarial más reconocido del mundo. Aceptado por más de 14,000 empresas en 160 países.',
    badge:  'Preparación Para el TOEIC',
    intl:   true,
  },
  {
    name:   'Certificación INA',
    abbr:   'INA',
    color:  '#006600',
    desc:   'Certificación técnica oficial del Instituto Nacional de Aprendizaje de Costa Rica. Reconocida por empresas y universidades nacionales.',
    badge:  'Certificado oficial CR',
    intl:   false,
  },
];

export const conveniosContent = {
  title:   '+34 convenios nacionales e internacionales',
  subtitle: 'Al ser parte de cualquiera de nuestras organizaciones aliadas, accedes a paquetes exclusivos de beneficios: descuentos especiales en matrícula, facilidades de pago, acceso prioritario al programa y acompañamiento personalizado durante todo tu proceso de aprendizaje.',
};

export const respaldosContent = {
  title:    'Tu inglés abre puertas reales',
  subtitle: 'Nuestros egresados trabajan en las empresas más reconocidas de Costa Rica y el mundo.',
  companies: ['Manpower', 'Amazon', 'SYKES', 'HELM360', 'Talent Job Fair', 'Místico Park'],
};

export const testimoniosContent = [
  {
    name:       'María Fernanda Rojas',
    role:       'Ejecutiva de Ventas, BAC Credomatic',
    text:       'Gracias a American English conseguí una promoción que llevaba años esperando. El programa intensivo me dio la confianza que necesitaba para hablar en reuniones internacionales.',
    stars:      5,
    initials:   'MF',
  },
  {
    name:       'Carlos Méndez',
    role:       'Ingeniero de Software, Amazon Costa Rica',
    text:       'Entré a Amazon directamente después de terminar el programa. La metodología conversacional hace toda la diferencia. En 9 meses pasé de nivel básico a C1.',
    stars:      5,
    initials:   'CM',
  },
  {
    name:       'Andrea Solano',
    role:       'Profesional de Salud, CCSS',
    text:       'El convenio con la CCSS me permitió acceder a precios especiales. Los profesores son excelentes y el método conversacional funciona de verdad.',
    stars:      5,
    initials:   'AS',
  },
  {
    name:       'Roberto Jiménez',
    role:       'Contador, Deloitte',
    text:       'Lo que más me gustó fue poder estudiar online a mi ritmo y practicar en las clases en vivo. En 9 meses logré el nivel que necesitaba para mi trabajo.',
    stars:      5,
    initials:   'RJ',
  },
  {
    name:       'Valeria Castro',
    role:       'Asistente Ejecutiva',
    text:       'Después de intentar aprender inglés de varias formas, American English fue lo que realmente funcionó. La clave es que hablas desde el primer día.',
    stars:      5,
    initials:   'VC',
  },
];

// Reseñas reales de Google — usadas como fallback cuando Supabase no tiene datos
export const resenasEjemplo = [
  {
    name:     'Julia Fernández',
    initials: 'JF',
    stars:    5,
    text:     'Yo como egresada opino que gracias al trabajo de la empresa, que siempre estuvo para apoyarnos, y de los profes que nos dieron todas las herramientas, hoy cuento con mejores herramientas tanto como persona como profesional. Verdaderamente el proceso se hizo con amor.',
    verified: true,
  },
  {
    name:     'Lauren Aguero',
    initials: 'LA',
    stars:    5,
    text:     'American English for Business ha sido para mí de gran ayuda y apoyo como ser humano y profesional. A través del aprendizaje en inglés he logrado comunicarme de mejor forma con mis clientes y pacientes, además se me han abierto nuevas oportunidades.',
    verified: true,
  },
  {
    name:     'Cinthia Ortiz',
    initials: 'CO',
    stars:    5,
    text:     'Mediante los cursos recibidos en American English he crecido no solo profesionalmente, sino también personalmente. Me siento muy segura de mí misma y con mucho potencial para laborar en muchas áreas.',
    verified: true,
  },
  {
    name:     'Alejandro Castro Solís',
    initials: 'AC',
    stars:    5,
    text:     "Learning with y'all was the best academic experience I've ever had. Thanks, American English for Business!",
    verified: true,
  },
  {
    name:     'Manuel Machado Espinoza',
    initials: 'MM',
    stars:    5,
    text:     'Muy buena experiencia, gran personal tanto profesores como personal administrativo. Muy contento y agradecido por el profesionalismo y dedicación.',
    verified: true,
  },
  {
    name:     'Leyber Valverde',
    initials: 'LV',
    stars:    5,
    text:     'Excelente atención y acompañamiento por parte de profesores y demás funcionarios comprometidos con dar un servicio de educación de calidad durante todo el proceso.',
    verified: true,
  },
  {
    name:     'Are GZ',
    initials: 'AG',
    stars:    5,
    text:     'Me siento muy agradecida que el MTSS haya elegido esta institución para nuestra enseñanza, ya que es una empresa con profesionales muy capacitados y con mucha calidad humana. Super recomendado para cualquiera que desee estudiar inglés.',
    verified: true,
  },
  {
    name:     'Kathya Hernández',
    initials: 'KH',
    stars:    5,
    text:     'Me siento muy agradecida de haber formado parte de esta gran institución, en la cual me brindaron una gran oportunidad de aprendizaje tanto en lo personal como profesional.',
    verified: true,
  },
];

// ── Redes sociales oficiales ─────────────────────────────────────────────────
export const socialLinks = {
  facebook:  'https://www.facebook.com/americanenglishforbusiness',
  instagram: 'https://www.instagram.com/americanenglishforbusiness/',
  whatsapp:  'https://wa.me/50687704499',
};

// Información legal del pie de página
export const footerInfo = {
  copyright: '© 2026 Comercializadora Estrella de Oriente C.E.O. | Todos los derechos reservados.',
  developer: 'Desarrollado por MediaForce',
};

export const navLinks = [
  { label: 'Inicio',          href: '/',           type: 'route' },
  { label: 'Inglés conversacional', href: '/programa', type: 'route' },
  { label: 'For Kids',        href: '/kids',        type: 'route', kids: true },
  { label: 'Convenios',       href: '/convenios',   type: 'route' },
  { label: 'Testimonios',    href: '/testimonios', type: 'route' },
  { label: 'Noticias',        href: '/noticias',    type: 'route' },
  { label: 'Contacto',        href: '/contacto',    type: 'route' },
];
